import React, { Component } from "react";
import { Block } from "reakit";
import { Box, Heading, Text } from "rebass";
import { Container, MobileHeader } from "../../components/Base";
import { connect } from "react-redux";
import { searchActions, searchSelectors } from "../../store/search";
import { withRouter } from "react-router";

import { FacultyProfileCard } from "../../components/Cards";

import FacultyContactMethod from "../../components/Modals/FacultyContactMethod";

import { schoolSelectors } from "../../store/school";
import { MobileFacultyPositionContainer } from "../../components/Base/styles";

class FacultyProfile extends Component {
  state = {
    contactPopup: false,
  };

  handleContact = async () => {
    const { firebase, data, profile, isFaculty, history } = this.props;
    let status = 0;
    if (isFaculty) {
      status = 1;
    }
    let accepted = {
      status: status,
      updated_at: Math.floor(Date.now() / 1000),
    };

    const members = [profile.id, data.id];

    const result = await this.checkIfExists(members);

    if (result !== true) {
      let newChatRef = firebase.chats().doc();
      newChatRef.set({
        creator_uid: profile.id,
        is_group: false,
        members: members,
        post_time: Math.floor(Date.now() / 1000),
        last_updated: Math.floor(Date.now() / 1000),
        messages: [],
        accepted,
        name: "",
      });
      history.push(`/app/chat/${newChatRef.id}`);
    }
  };

  toggleContact = () => {
    const { contactPopup } = this.state;
    this.setState({ contactPopup: !contactPopup });
  };

  checkIfExists = async (members) => {
    const { firebase, history } = this.props;
    try {
      let chatQuery = await firebase
        .chats()
        .where("members", "array-contains", members[0])
        .where("creator_uid", "==", members[1])
        .where("is_group", "==", false)
        .get();
      //console.log('chatquery', chatQuery);
      if (chatQuery.docs.length > 0) {
        history.push(`/app/chat/${chatQuery.docs[0].id}`);
        return true;
      } else {
        chatQuery = await firebase
          .chats()
          .where("members", "array-contains", members[1])
          .where("creator_uid", "==", members[0])
          .where("is_group", "==", false)
          .get();
        if (chatQuery.docs.length > 0) {
          history.push(`/app/chat/${chatQuery.docs[0].id}`);
          return true;
        }
      }
    } catch (err) {
      //console.log(err)
    }
    return false;
  };

  render() {
    const { data } = this.props;

    return (
      <Box>
        <MobileHeader>
          <Heading pt={3}>{data.first_name}'s Profile</Heading>
          <Text color={"meta"} fontSize={"17px"} fontWeight={600} pb={2}>
            {data.position}
          </Text>
        </MobileHeader>

        <Block>
          <Container>
            <FacultyProfileCard profile={data}/>
          </Container>
        </Block>
        <MobileFacultyPositionContainer bg="#fff" color="#2b80b9" fontSize="16px">
          <FacultyContactMethod
            profile={data}
            handleChat={this.handleContact}
            noButton
          />
        </MobileFacultyPositionContainer>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
  search: searchSelectors.refreshSearch(state.search),
  filters: searchSelectors.refreshFilters(state.search),
  students: searchSelectors.refreshCurrentResults(state.search),
});

const mapDispatchToProps = (dispatch) => ({
  updateSearch: (term) => {
    dispatch(searchActions.updateSearch(term));
  },
  clearSearch: () => {
    dispatch(searchActions.clearSearch());
  },
  updateStudents: (students) => {
    dispatch(searchActions.updateStudents(students));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FacultyProfile)
);
